import './styles.scss';

import { faCirclePlus, faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, CircularProgress, Switch } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { Dropdown } from '../../../../dropdown/dropdown';
import Input from '../../../../input/input';

interface Props {
  tokens: { value: string; label: string; isVisible: boolean }[];
  handleUpdate: (tokens: any[]) => void;
  isLoading?: boolean;
}

const TokenFilter = (props: Props) => {
  const { tokens, handleUpdate, isLoading = false } = props;
  const [tokenList, setTokenList] = useState<
    { id: string; value: string; label: string; isVisible: boolean }[]
  >(tokens.map((tk) => ({ id: tk.value, ...tk })));
  const [search, setSearch] = useState('');
  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);

  const handleOnCancel = () => {
    setOpen(false);
  };

  const handleOnApply = () => {
    handleUpdate(
      tokenList.map((tk) => ({
        value: tk.value,
        label: tk.label,
        isVisible: tk.isVisible,
      })),
    );
    setOpen(false);
  };

  useEffect(() => {
    setTokenList(tokens.map((tk) => ({ id: tk.value, ...tk })));
  }, [tokens, setTokenList]);

  const filteredList = useMemo(() => {
    let arr = [...tokenList];

    if (checked) {
      arr = arr.filter((tk) => tk.isVisible);
    }

    if (search) {
      return arr.filter((tk) => tk.value.toLowerCase().includes(search.toLowerCase()));
    } else {
      return arr;
    }
  }, [search, checked, tokenList]);

  const hasSelectedToken = tokenList && tokenList.filter((tk) => tk.isVisible).length > 0;

  const renderListToken = () => {
    if (isLoading) {
      return (
        <div className="loading-list">
          <CircularProgress size={34} />
        </div>
      );
    }

    if (!hasSelectedToken && checked) {
      return (
        <div className="empty-list">
          <span>No tokens are selected</span>
        </div>
      );
    }

    const listToRender = filteredList;

    return listToRender.map((token, i) => {
      const handleChangeCheckBox = () => {
        setTokenList((prev) => {
          const nArr = [...prev];

          const indexToken = nArr.findIndex((tk) => tk.id === token.id);

          if (indexToken < 0) return nArr;

          nArr[indexToken] = {
            ...nArr[indexToken],
            isVisible: !nArr[indexToken].isVisible,
          };

          return nArr;
        });
      };

      return (
        <div key={i.toString()} className="item-list-container">
          <Checkbox checked={token.isVisible} onChange={handleChangeCheckBox} className="check" />
          <span>{token.label}</span>
        </div>
      );
    });
  };

  return (
    <div className="funding-token-filter">
      <Button
        className="bt-filter"
        onClick={() => {
          setOpen((prev) => !prev);
        }}
      >
        <FontAwesomeIcon icon={faCirclePlus} className="icon" />
        <span>Add token</span>
      </Button>
      <Dropdown isOpen={open} setIsOpen={setOpen} classNames="dropdown-class">
        <div className="content">
          <div className="menu-header">
            <span className="menu-header-title">Add token</span>

            <div className="switch-selected-only">
              <span>Show selected only</span>
            </div>
            <Switch
              value="selected-only"
              checked={checked}
              onChange={(e) => {
                setChecked(e.target.checked);
              }}
            />
          </div>

          <Input
            icon={<FontAwesomeIcon icon={faSearch} />}
            placeholder="Search"
            className="search-input"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />

          <div className="list-token">{renderListToken()}</div>

          {!isLoading && (
            <div className="buttons">
              <Button className="cancel-button" onClick={handleOnCancel}>
                Cancel
              </Button>
              <Button className="apply-button" onClick={handleOnApply} disabled={!hasSelectedToken}>
                Apply
              </Button>
            </div>
          )}
        </div>
      </Dropdown>
    </div>
  );
};

export default TokenFilter;
